import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import { Divider, Stack, Tab, Tabs } from '@mui/material'
import { useFeatureFlagContext } from '@/feature_flags/FeatureFlagProvider'
import TabPanel from '@/components/TabPanel'
import WorkflowStateEvents from '@/components/workflow-state-events-page/WorkflowStateEvents'
import WorkflowStateRules from './WorkflowStateRules'
import WorkflowStateSettings from './WorkflowStateSettings'

export const tabsMap: Record<string, number> = {
  settings: 0,
  events: 1,
  rules: 2,
}

export default function WorkflowStateDetails() {
  const featureFlags = useFeatureFlagContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(
    tabsMap[searchParams.get('tab') || ''] ?? 1,
  )

  const handleChange = (
    _e: React.SyntheticEvent<Element, Event>,
    newValue: number,
  ) => {
    setSelectedTab(newValue)
    setSearchParams(
      (prev) => {
        prev.set('tab', Object.keys(tabsMap)[newValue])
        return prev
      },
      { replace: true },
    )
  }

  useEffect(() => {
    if (!searchParams.has('tab')) {
      const defaultTab = Object.keys(tabsMap)[0]
      setSearchParams(
        (prev) => {
          prev.set('tab', defaultTab)
          return prev
        },
        { replace: true },
      )
      setSelectedTab(0)
    }
  }, [searchParams, setSearchParams])

  return (
    <Stack direction="column" sx={{ pt: 1, pb: 2.5 }} spacing={2}>
      <div>
        <Tabs value={selectedTab} onChange={handleChange}>
          <Tab label="Settings" />
          <Tab label="Events" />
          {featureFlags.show_rules_tab_in_workflow_states && (
            <Tab label="Rules" />
          )}
        </Tabs>
        <Divider />
      </div>
      <TabPanel value={selectedTab} index={tabsMap.settings} sx={{ px: 1 }}>
        <WorkflowStateSettings />
      </TabPanel>
      <TabPanel value={selectedTab} index={tabsMap.events} sx={{ px: 1 }}>
        <WorkflowStateEvents />
      </TabPanel>
      {featureFlags.show_rules_tab_in_workflow_states && (
        <TabPanel value={selectedTab} index={tabsMap.rules} sx={{ px: 1 }}>
          <WorkflowStateRules />
        </TabPanel>
      )}
    </Stack>
  )
}
